// extracted by mini-css-extract-plugin
export default {"pickerContainer":"EmojiPicker__pickerContainer___B3hsP","emoji-mart-emoji":"EmojiPicker__emoji-mart-emoji___mD6IO","popover":"EmojiPicker__popover___DEmk2"};